import { FromViewState } from 'owa-mail-compose-store';
import FindControlViewState, {
    FindResultType,
    DirectorySearchType,
} from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'initializeFromWellFindControlViewState',
    function initializeFromWellFindControlViewState(viewState: FromViewState) {
        const findControlViewState: FindControlViewState = {
            queryString: '',
            findPeopleFeedbackManager: null,
            findResultSet: [],
            findResultType: FindResultType.None,
            findResultHightlightIndex: -1,
            isSearching: false,
            shouldShowFindResult: false,
            directorySearchType: DirectorySearchType.None,
        };

        viewState.fromWellFindControlViewState = findControlViewState;
    }
);
